export default __webpack_public_path__ + "dd37b39edcfc70d7def75ce7d90b1db8.svg";